module.exports = __webpack_public_path__ + "img/horizontal_3_6_8004.2e3fb82e.png";